import { colors, fonts } from '@grupoboticario/flora-tokens/dist/monocromatico/web/ds'

export const monocromatico = {
  colors,
  fonts,
}
